import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Home from '@/page/home';
import Payment from '@/page/payment';
import Recharge from '@/page/recharge';
import PaySuccess from '@/page/paysuccess'
import RechargeSuccess from '@/page/rechargesuccess'
import TopupVoucher from '@/page/topupvoucher'

export default class RouteConfig extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/home" component={Home} />
                    <Route path="/payment" component={Payment} />
                    <Route path="/recharge" component={Recharge} />
                    <Route path="/paysuccess" component={PaySuccess} />
                    <Route path="/rechargesuccess" component={RechargeSuccess} />
                    <Route path="/vtopup" component={TopupVoucher} />
                    <Route path="/vtopuprecord" component={TopupVoucher} />
                    <Redirect to="/home" />
                </Switch>
            </Router>
        )
    }
}